/* eslint-disable no-unused-vars */

export default {
    Assert: function() {},
    StrictAssert: function() {}
};




//////////////////
// WEBPACK FOOTER
// ./src/utility/Assert.Production.js
// module id = Zyv1
// module chunks = 1